module.exports = __webpack_public_path__ + "static/media/HighLightInActive.22477593.png";